import React, { useContext, useState, useEffect } from 'react';

import { Spinner } from 'react-bootstrap';
import _ from 'lodash';

import AppContext from '../../../context';
import { createPortfolio } from '../../../../api';
import { ReactComponent as TrashGrey } from '../../../../assets/icons/trash-grey.svg';
import { ReactComponent as Cross } from '../../../../assets/icons/cross.svg';
import { ReactComponent as AngleRight } from '../../../../assets/icons/angle-right.svg';
import { ReactComponent as PlusCircle } from '../../../../assets/icons/plus-circle.svg';
import './step_one.component.css';

const ManageStepOne = (props) => {
  const {
    setStep,
    setCurrentPfId,
    setShowDeletePf,
    setDeleteFromRef,
    setContext,
    onClose,
  } = props;
  const context = useContext(AppContext);
  //state
  const [isAddingPf, setIsAddingPf] = useState(false);
  const [addPfError, setAddPfError] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const getPortfolios = () => {
    return context.portfolios.filter(
      (pf) => !pf.is_dummy && pf.id !== 'family',
    );
  };

  const showAddPortfolio = () => {
    if (context.is_sample) return false;
    let pfs = context.portfolios.filter(
      (pf) => !pf.is_dummy && pf.id !== 'family',
    );
    if (pfs.length < context.planDetails.ind_portfolio.portfolios) {
      return true;
    }
    return false;
  };

  const onCreatePortfolio = async () => {
    setAddPfError(false);
    setIsAddingPf(true);
    try {
      const name = context.portfolios.find((pf) => pf.is_dummy).name;
      const res = await createPortfolio(name);
      let pfs = _.cloneDeep(context.portfolios);
      const pfIdx = context.portfolios.findIndex((_pf) => _pf.is_dummy);
      pfs[pfIdx] = {
        id: res.data.id,
        name: res.data.title,
        is_empty: true,
        is_mf_eligible_to_sync: true,
        reset_data: 0,
      };
      //setPortfolios(pfs);
      setContext({ portfolios: pfs });
      setCurrentPfId(res.data.id);
      setStep('empty_pf');
    } catch (error) {
      setAddPfError(true);
      setIsAddingPf(false);
    }
  };

  useEffect(() => {
    if (window.innerWidth <= 480) {
      setIsMobile(true);
    }
    const handleResize = _.debounce(() => {
      if (window.innerWidth <= 480 && !isMobile) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    }, 100);
    window.addEventListener('resize', handleResize);
    () => {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <section className="modal-header">
        <div className="head">
          <span className="head">Manage Portfolio</span>
        </div>
        <button type="button" onClick={onClose}>
          <Cross />
        </button>
      </section>
      <section className="manage_one">
        <div className="position-relative">
          {/* <span className="step-text">STEP 1</span> */}
          <h5 className="step-heading pt-1 mb-0">Select a Portfolio</h5>
        </div>
        <div className="position-relative overflow-auto flex-grow">
          {getPortfolios().map((pf) => {
            return (
              <div key={pf.id} className="manage_pf__card">
                <div class="name_block">
                  <div className="name">{pf.name}</div>
                  {(!context.mfInBeta ||
                    context.planDetails.name === 'premium') && (
                    <div class="labels_block">
                      {pf.has_equity_or_etf ? (
                        <div class="stocks_label label">Stocks</div>
                      ) : (
                        ''
                      )}
                      {pf.has_mfs ? (
                        <div class="mfs_label label">Mutual Funds</div>
                      ) : (
                        ''
                      )}
                    </div>
                  )}
                </div>
                <div className="manage_block">
                  {getPortfolios().length > 1 && !isMobile && (
                    <>
                      <button
                        type="button"
                        className="delete_btn"
                        onClick={() => {
                          setCurrentPfId(pf.id);
                          setDeleteFromRef();
                          setShowDeletePf(true);
                        }}
                      >
                        <TrashGrey />
                      </button>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="1"
                        height="18"
                        viewBox="0 0 1 18"
                        fill="none"
                      >
                        <path
                          d="M0.5 0.940918V16.9409"
                          stroke="#C4C4C4"
                          stroke-linecap="round"
                        />
                      </svg>
                    </>
                  )}
                  <button
                    type="button"
                    className="manage_btn"
                    onClick={() => {
                      setCurrentPfId(pf.id);
                      if (pf.is_empty) {
                        setStep('empty_pf');
                        return;
                      }
                      setStep('manage_two');
                    }}
                  >
                    {isMobile ? (
                      <AngleRight />
                    ) : (
                      <span>
                        Manage <AngleRight />
                      </span>
                    )}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
        {showAddPortfolio() ? (
          <>
            <button className="create-pf" onClick={() => onCreatePortfolio()}>
              {isAddingPf ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    color="#0081f2"
                    className="mr-2"
                  />
                  Adding portfolio
                </>
              ) : (
                <>
                  <span>
                    <PlusCircle />
                  </span>
                  <span>New Portfolio</span>
                </>
              )}
            </button>
            {addPfError && (
              <p className="text-danger">
                Something went wrong. Please try again
              </p>
            )}
          </>
        ) : null}
      </section>
    </>
  );
};

export default ManageStepOne;
